import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Services from '@/pages/Services';
import ServiceDetail from '@/pages/ServiceDetail';
import { Portfolio, PortfolioDetail } from '@/pages/Portfolio';
import Eureka1 from '@/pages/Eureka1';
import { Blog, BlogPost } from '@/pages/Blog';
import Contact from '@/pages/Contact';

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/:slug" element={<PortfolioDetail />} />
          <Route path="/results" element={<Navigate to="/portfolio" replace />} />
          <Route path="/eureka1" element={<Eureka1 />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: '#1C1C1C',
            color: '#F4EFEA',
            border: '1px solid #C9A24D',
            borderRadius: '0',
            fontFamily: 'Inter, sans-serif',
            letterSpacing: '0.02em',
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
